import { useTheme } from '@emotion/react';
import { IconInfoFilled, IconWarningFilled, IconAlertFilled } from '@hubble/icons/web';
import 'react';
import { Button } from '../Button/index.js';
import { Flex } from '../Flex/index.js';
import { HubbleProvider } from '../ThemeProvider/index.js';
import { variantToThemeSchemeMap } from './constants.js';
import { SystemAlertWrapper, SystemAlertText, SystemAlertButtonContainer } from './styles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

const AlertIconMap = {
  informational: IconInfoFilled,
  warning: IconWarningFilled,
  negative: IconAlertFilled
};
function SystemAlert({
  variant = 'negative',
  onClose,
  children,
  'data-testid': dataTestId,
  actionButtonProps,
  secondaryButtonProps,
  size = 'md'
}) {
  const {
    translate
  } = useTheme();
  const scheme = variantToThemeSchemeMap[variant];
  const AlertIcon = AlertIconMap[variant];
  const hasActionButton = Boolean(actionButtonProps);
  return jsx(HubbleProvider, {
    scheme: scheme,
    children: jsxs(SystemAlertWrapper, {
      "data-testid": dataTestId,
      variant: variant,
      p: 1.5,
      hasActionButton: hasActionButton,
      justifyContent: "space-between",
      children: [jsx(Flex, {
        align: "center",
        children: jsxs(Flex, {
          align: "flex-start",
          children: [jsx(Flex, {
            shrink: 0,
            children: jsx(AlertIcon, {
              size: size
            })
          }), jsx(SystemAlertText, {
            size: size,
            ml: 1.5,
            mr: 1.5,
            as: "div",
            "data-testid": dataTestId && `${dataTestId}-text`,
            children: children
          })]
        })
      }), (Boolean(onClose) || hasActionButton) && jsxs(SystemAlertButtonContainer, {
        hasActionButton: hasActionButton,
        children: [hasActionButton && jsx(Button.Primary, {
          ...actionButtonProps,
          mr: 1,
          display: actionButtonProps.href ? 'inline-flex' : 'inline',
          "data-testid": dataTestId && `${dataTestId}-action-button`,
          size: "sm"
        }), (Boolean(onClose) || Boolean(secondaryButtonProps)) && jsx(Button.Secondary, {
          "data-testid": dataTestId && `${dataTestId}-dismiss-button`,
          display: secondaryButtonProps !== null && secondaryButtonProps !== void 0 && secondaryButtonProps.href ? 'inline-flex' : 'inline',
          cta: translate('SystemAlert.dismiss'),
          size: "sm",
          onClick: onClose,
          ...secondaryButtonProps
        })]
      })]
    })
  });
}

export { SystemAlert };
